export default __webpack_public_path__ + "static/media/Telegram.2589dcf6.png";